import React from 'react'

export default function FormToggle(props) {
    return (
        <div>
            <div>
                <img src={props.logo} className='auth__form_logo' alt='logo' />
            </div>
            <div className="form__buttons_step" onClick={props.shownPass}>

                <button type="button" onClick={props.onAuth} className={"btn_auth_toggle btn_orange" + (!props.switcher ? ' active_btn_auth' : '') + (props.isValid('fieldsAuth') && !props.sendRequest ? "" : "")}
                >{props.context.translate("Войти")}</button>

                <button className={"btn_auth_toggle btn_clear_blue_auth" + (props.switcher ? ' active_btn_auth' : '')} onClick={props.onReg}>
                    {props.context.translate("Зарегистрироваться")}
                </button>
            </div>
        </div>
    );
}